<div *ngIf="cooperateUser">
  <vdr-card
    [title]="'common.coopApprovalStatus' | translate"
    style="margin-bottom: 15px"
  >
    <vdr-action-bar>
      <vdr-ab-left>
        <vdr-form-field>
          <label style="margin-right: 4px; margin-bottom: 20px">
            {{ "common.approval" | translate }}
            {{ "common.status" | translate }}:
          </label>
          <!-- <label *ngIf="isApproved">{{ "common.approved" | translate }}</label>
          <label *ngIf="!isApproved">{{ "common.denied" | translate }}</label> -->
          <input
            style="margin-left: 5px"
            type="checkbox"
            clrToggle
            name="enabled"
            [(ngModel)]="isApproved"
          /> </vdr-form-field
      ></vdr-ab-left>
      <vdr-ab-right> </vdr-ab-right>
    </vdr-action-bar>
    <div *ngIf="cooperateUser" class="form-grid">
      <vdr-form-field [label]="'common.representative' | translate">
        <label>{{ cooperateUser.representative }}</label>
      </vdr-form-field>
      <vdr-form-field [label]="'common.taxCode' | translate">
        <label>{{ cooperateUser.taxCode }}</label>
      </vdr-form-field>
      <vdr-form-field [label]="'common.attachments' | translate">
        <img
          *ngFor="let attachment of cooperateUser.attachments"
          [src]="previewAttachment(attachment)"
          (click)="previewAsset(attachment)"
          style="
            width: 100px;
            height: 100px;
            margin-right: 10px;
            cursor: pointer;
          "
        />
      </vdr-form-field>
    </div>
  </vdr-card>
</div>
